import { useState } from 'react'
import { Chip } from '@mui/joy'
import { MUSICAL_KEYS } from '../../data/keys'
import './possibleKeys.scss'

const PossibleKeys = ({selectedNotes, setSelectedNotes}) => {
    const [storedNotes, setStoredNotes] = useState([]);

    const findVariant = (key) => {
        const lengthsMatch = key.notes.length === selectedNotes.length;
        const selectedNotesInKey = areSelectedNotesInKey(key);
        
        if (lengthsMatch && selectedNotesInKey) {
            return 'solid'
        } else if (selectedNotesInKey) {
            return 'soft'
        } else {
            return 'outlined'
        }
    }

    const areSelectedNotesInKey = (key) => {
        return selectedNotes.every(note => key.notes.includes(note))
    }

    const onKeyClick = (key) => {
        if(areSelectedNotesInKey(key) && key.notes.length === selectedNotes.length){
            setSelectedNotes(storedNotes);
        }else{
            setStoredNotes(selectedNotes);
            setSelectedNotes(key.notes); 
        }
        
    }

    const sortedMusicalKeys = [...MUSICAL_KEYS]. sort((a, b) => {
        const aIsInKey = areSelectedNotesInKey(a);
        const bIsInKey = areSelectedNotesInKey(b);

        if(aIsInKey && !bIsInKey){
            return -1;
        }

        if(!aIsInKey && bIsInKey){
            return 1;
        }

        return 0;
    })

    return (
        <div className='possible-keys'>
            {
                sortedMusicalKeys.map((key, index) => (
                    <Chip 
                    key={`${key.root}-${key.type}-${index}`}
                    variant={findVariant(key)}
                    color={areSelectedNotesInKey(key) ? 'success' : 'neutral'}
                    onClick={() => onKeyClick(key)}
                    >{`${key.root} ${key.type}`}</Chip>
                ))
            }
        </div>
    )
}

export default PossibleKeys